const productKeyAlphabet = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const currentKeyLength = 25;
const legacyKeyLength = 30;

function isProductKeyContinuation(value: string) {
  return value === "-" || productKeyAlphabet.includes(value);
}

function crc16(payload: string) {
  let crc = 0xffff;
  for (const character of payload) {
    crc ^= character.charCodeAt(0) << 8;
    for (let bit = 0; bit < 8; bit += 1) {
      crc = ((crc & 0x8000) !== 0 ? (crc << 1) ^ 0x1021 : crc << 1) & 0xffff;
    }
  }
  return crc;
}

function hasValidChecksum(candidate: string) {
  if (candidate.length === currentKeyLength) {
    return candidate.at(-1) === productKeyAlphabet[crc16(candidate.slice(0, -1)) & 0x1f];
  }
  if (candidate.length === legacyKeyLength && candidate.startsWith("TB")) {
    const value = crc16(candidate.slice(2, 28)) & 0x03ff;
    return candidate.slice(28) === productKeyAlphabet[value >> 5] + productKeyAlphabet[value & 31];
  }
  return false;
}

export function containsProductKey(input: string) {
  const upper = input.toUpperCase();
  for (let start = 0; start < upper.length; start += 1) {
    if (!productKeyAlphabet.includes(upper[start]) || (start > 0 && isProductKeyContinuation(upper[start - 1]))) continue;
    let candidate = "";
    for (let index = start; index < upper.length; index += 1) {
      const value = upper[index];
      if (value === "-" || value === " " || value === "\t" || value === "\n" || value === "\r") continue;
      if (!productKeyAlphabet.includes(value)) break;
      candidate += value;
      if (candidate.length === currentKeyLength || candidate.length === legacyKeyLength) {
        const bounded = index + 1 === upper.length || !isProductKeyContinuation(upper[index + 1]);
        if (bounded && hasValidChecksum(candidate)) return true;
        if (candidate.length === legacyKeyLength) break;
      }
    }
  }
  return false;
}
